import { useEffect } from 'react'
import { Navigate, useNavigate } from 'react-router'
import { useAuth } from '../auth/useAuth'
import { homeFor, rolesOf } from '../auth/roles'

/** Landing page after Microsoft sign-in: the token arrives in the URL fragment, is taken, and the address is cleaned. */
export default function SsoCompletePage() {
  const { signIn } = useAuth()
  const navigate = useNavigate()
  const token = new URLSearchParams(window.location.hash.slice(1)).get('token')
  useEffect(() => {
    if (!token) return
    window.history.replaceState(null, '', '/sso-complete')
    signIn(token)
    navigate(homeFor(rolesOf(token)), { replace: true })
  }, [token, signIn, navigate])
  return token ? <p role="status">Signing you in…</p> : <Navigate to="/login?sso_error=failed" replace />
}
